var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1327",
    "data-name": "Group 1327",
    transform: "translate(-30.375 -123)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_316",
    "data-name": "Rectangle 316",
    transform: "translate(30.375 123)",
    fill: "rgba(158,51,35,0.2)",
    stroke: "rgba(158,51,35,0.2)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "call_01",
    d: "M16.82,21.25a8.51,8.51,0,0,1-3.3-.735,17.465,17.465,0,0,1-3.34-1.916,29.036,29.036,0,0,1-3.135-2.67A27.792,27.792,0,0,1,4.373,12.8a17.36,17.36,0,0,1-1.9-3.312A8.613,8.613,0,0,1,1.75,6.171a5.606,5.606,0,0,1,.381-2.056,4.968,4.968,0,0,1,1.247-1.8A3.378,3.378,0,0,1,5.787,1.25a2.516,2.516,0,0,1,1.051.233,2.129,2.129,0,0,1,.893.753L9.89,5.278a3.6,3.6,0,0,1,.447.791,2.09,2.09,0,0,1,.186.828,1.974,1.974,0,0,1-.3,1.023A3.721,3.721,0,0,1,9.6,8.71l-.633.66A.454.454,0,0,0,9,9.436a7.154,7.154,0,0,0,.763,1.033c.456.521.884,1,1.312,1.433.549.54,1,.967,1.433,1.321a6.059,6.059,0,0,0,1.079.772l-.019.047.679-.67a3.474,3.474,0,0,1,.837-.642,1.964,1.964,0,0,1,1.814-.1,4.235,4.235,0,0,1,.781.437l3.088,2.2a2,2,0,0,1,.744.884,2.692,2.692,0,0,1,.2,1,3.1,3.1,0,0,1-.3,1.312,4.332,4.332,0,0,1-.744,1.116,4.771,4.771,0,0,1-1.777,1.274A5.492,5.492,0,0,1,16.82,21.25ZM5.787,2.645a2.039,2.039,0,0,0-1.442.67,3.569,3.569,0,0,0-.912,1.312,4.07,4.07,0,0,0-.288,1.544,7.172,7.172,0,0,0,.614,2.772,15.528,15.528,0,0,0,1.749,3.033,25.736,25.736,0,0,0,2.521,2.958A26.192,26.192,0,0,0,11,17.464a15.114,15.114,0,0,0,3.06,1.758,5.548,5.548,0,0,0,4.307.326,3.434,3.434,0,0,0,1.274-.921,3.017,3.017,0,0,0,.521-.781,1.648,1.648,0,0,0,.167-.716,1.111,1.111,0,0,0-.1-.465.7.7,0,0,0-.26-.279l-3.088-2.2a2.667,2.667,0,0,0-.512-.288.489.489,0,0,0-.6.028,2.121,2.121,0,0,0-.54.419l-.707.7a1.326,1.326,0,0,1-1.349.279l-.251-.112a7.93,7.93,0,0,1-1.321-.94c-.447-.381-.93-.828-1.516-1.4-.456-.465-.912-.958-1.386-1.507a7.937,7.937,0,0,1-.949-1.312l-.112-.279a1.736,1.736,0,0,1-.074-.465,1.194,1.194,0,0,1,.353-.865l.7-.726a2.694,2.694,0,0,0,.419-.521.6.6,0,0,0,.1-.316.865.865,0,0,0-.074-.3,2.669,2.669,0,0,0-.3-.493L6.6,3.036a.857.857,0,0,0-.344-.288A1.165,1.165,0,0,0,5.787,2.645Zm7.777,11.4-.149.633.251-.651A.115.115,0,0,0,13.564,14.05Z",
    transform: "translate(38.644 131.75)",
    fill: "#9e3323"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.0b078b60b0acde49773e21555c330d55.svg";
export { ForwardRef as ReactComponent };